let NotificationDB = "NotificationDB";
let ObjectStoreNotificationUnreadCount = "notificationUnreadCount";
let ObjectStoreNotificationUnread = "notificationUnread";
let ObjectStoreNotificationRead = "notificationRead";
const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;

export const OpenNotificationIndexedDB = () => {
  return new Promise((resolve, reject) => {
    if (!indexedDB) throw new Error("Your browser doesn't support IndexedBD");

    const request = indexedDB.open(NotificationDB, 1);

    request.onerror = (e) => {
      console.error(`IndexedDB error: ${request.errorCode}`);
    };

    request.onsuccess = (e) => {
      const db = e.target.result;
      resolve(db);
    };

    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      db.createObjectStore(ObjectStoreNotificationUnreadCount, { keyPath: "merchantId" });
      db.createObjectStore(ObjectStoreNotificationUnread, { keyPath: "merchantId" });
      db.createObjectStore(ObjectStoreNotificationRead, { keyPath: "merchantId" });
    };
  });
};

export const AddUnreadNotificationToIndexedDB = (notificationModel) => {
  return new Promise(async (resolve, reject) => {
    const db = await OpenNotificationIndexedDB();
    const request = db
      .transaction([ObjectStoreNotificationUnread], "readwrite")
      .objectStore(ObjectStoreNotificationUnread)
      .add(notificationModel);

    request.onsuccess = (event) => {
      var tabId = event.target.result;
      db.close();
      resolve(tabId);
    };
    request.onerror = (err) => {
      console.error(`Error to add new Tap: ${err}`);
      resolve(0);
    };
  });
};

export const UpdateUnreadNotificationToIndexedDB = (notificationModel) => {
  return new Promise(async (resolve, reject) => {
    const db = await OpenNotificationIndexedDB();
    const request = db
      .transaction([ObjectStoreNotificationUnread], "readwrite")
      .objectStore(ObjectStoreNotificationUnread)
      .put({ ...notificationModel });

    request.onsuccess = (event) => {
      var tabId = event.target.result;
      db.close();
      resolve(tabId);
    };
    request.onerror = (err) => {
      console.error(`Error to add new Tap: ${err}`);
      resolve(0);
    };
  });
};

export const GetUnreadNotificationFromIndexedDB = (merchantId) => {
  return new Promise(async (resolve, reject) => {
    const db = await OpenNotificationIndexedDB();
    const request = db
      .transaction([ObjectStoreNotificationUnread], "readwrite")
      .objectStore(ObjectStoreNotificationUnread)
      .get(merchantId);

    request.onsuccess = () => {
      const taps = request.result;
      db.close();
      resolve(taps);
    };

    request.onerror = (err) => {
      console.error(`Error to get all taps: ${err}`);
      resolve(null);
    };
  });
};

export const AddReadNotificationToIndexedDB = (notificationModel) => {
  return new Promise(async (resolve, reject) => {
    const db = await OpenNotificationIndexedDB();
    const request = db
      .transaction([ObjectStoreNotificationRead], "readwrite")
      .objectStore(ObjectStoreNotificationRead)
      .add(notificationModel);

    request.onsuccess = (event) => {
      var tabId = event.target.result;
      db.close();
      resolve(tabId);
    };
    request.onerror = (err) => {
      console.error(`Error to add new Tap: ${err}`);
      resolve(0);
    };
  });
};

export const UpdateReadNotificationToIndexedDB = (notificationModel) => {
  return new Promise(async (resolve, reject) => {
    const db = await OpenNotificationIndexedDB();
    const request = db
      .transaction([ObjectStoreNotificationRead], "readwrite")
      .objectStore(ObjectStoreNotificationRead)
      .put({ ...notificationModel });

    request.onsuccess = (event) => {
      var tabId = event.target.result;
      db.close();
      resolve(tabId);
    };
    request.onerror = (err) => {
      console.error(`Error to add new Tap: ${err}`);
      resolve(0);
    };
  });
};

export const GetReadNotificationFromIndexedDB = (merchantId) => {
  return new Promise(async (resolve, reject) => {
    const db = await OpenNotificationIndexedDB();
    const request = db
      .transaction([ObjectStoreNotificationRead], "readwrite")
      .objectStore(ObjectStoreNotificationRead)
      .get(merchantId);

    request.onsuccess = () => {
      const taps = request.result;
      db.close();
      resolve(taps);
    };

    request.onerror = (err) => {
      console.error(`Error to get all taps: ${err}`);
      resolve(null);
    };
  });
};

export const AddNotificationCountToIndexedDB = (notificationCountModel) => {
  return new Promise(async (resolve, reject) => {
    const db = await OpenNotificationIndexedDB();
    const request = db
      .transaction([ObjectStoreNotificationUnreadCount], "readwrite")
      .objectStore(ObjectStoreNotificationUnreadCount)
      .add(notificationCountModel);

    request.onsuccess = (event) => {
      var tabId = event.target.result;
      db.close();
      resolve(tabId);
    };
    request.onerror = (err) => {
      console.error(`Error to add new Tap: ${err}`);
      resolve(0);
    };
  });
};

export const UpdateNotificationCountToIndexedDB = (notificationCountModel) => {
  return new Promise(async (resolve, reject) => {
    const db = await OpenNotificationIndexedDB();
    const request = db
      .transaction([ObjectStoreNotificationUnreadCount], "readwrite")
      .objectStore(ObjectStoreNotificationUnreadCount)
      .put({ ...notificationCountModel });

    request.onsuccess = (event) => {
      var tabId = event.target.result;
      db.close();
      resolve(tabId);
    };
    request.onerror = (err) => {
      console.error(`Error to add new Tap: ${err}`);
      resolve(0);
    };
  });
};

export const GetNotificationCountFromIndexedDB = (merchantId) => {
  return new Promise(async (resolve, reject) => {
    const db = await OpenNotificationIndexedDB();
    const request = db
      .transaction([ObjectStoreNotificationUnreadCount], "readwrite")
      .objectStore(ObjectStoreNotificationUnreadCount)
      .get(merchantId);

    request.onsuccess = () => {
      const taps = request.result;
      db.close();
      resolve(taps);
    };

    request.onerror = (err) => {
      console.error(`Error to get all taps: ${err}`);
      resolve(null);
    };
  });
};

export const DeleteNotificationIndexedDB = () => {
  return new Promise((resolve, reject) => {
    if (!indexedDB) throw new Error("Your browser doesn't support IndexedBD");

    const request = indexedDB.deleteDatabase(NotificationDB);

    request.onerror = (event) => {
      console.error("Error deleting database.");
      resolve();
    };

    request.onblocked = (event) => {
      console.error("blocked: " + event);
    };

    request.onsuccess = (event) => {
      resolve();
    };
  });
};
